import { GiphyFetch } from '@giphy/js-fetch-api'
import { colors } from '@giphy/react-giphy-brand'
import { sample } from 'lodash'
import React from 'react'
import { FOUR_O_FOUR_API_KEY } from 'shared/api'
import Grid from 'shared/components/grid'
import styled, { createGlobalStyle } from 'styled-components'

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 0 50px;
`

const Message = styled.div`
    display: flex;
    flex-direction: column;
    font-weight: bold;
    align-items: center;
    line-height: 15px;
    text-align: center;
    width: 400px;
    margin: 50px 0 15px;
    & a {
        color: ${colors.giphyBlue};
    }
`

const Footer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: fixed;
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
    bottom: 0;
    width: 100vw;
    height: 30vh;
    pointer-events: none;
`

const Button = styled.a<{ is403?: boolean }>`
    background: ${colors.primaryCTA};
    width: 300px;
    color: white;
    line-height: 36px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 60px;
    margin-top: ${props => (props.is403 ? `20px` : `0px`)};
    pointer-events: auto;
`

const Arrow = styled.div`
    color: white;
    margin-bottom: 15px;
`
const errorGifs = ['img/error_pages/text/dang.gif', 'img/error_pages/text/oops.gif', 'img/error_pages/text/woof.gif']

const errorBgs = [
    'img/error_pages/bg/bg_blocks.gif',
    'img/error_pages/bg/bg_cupcakes_small.gif',
    'img/error_pages/bg/bg_pizza.gif',
    'img/error_pages/bg/bg_shine_small.gif',
    'img/error_pages/bg/bg_tacos.gif',
]
const errorText = sample(errorGifs)
const errorBG = sample(errorBgs)

const GlobalStyle = createGlobalStyle`
  body {
    background-color: transparent;
  }

  html {
    background-image: url('${(window as any).STATIC_URL + errorBG}');
    background-size: 100%;
  }
`

const fourOHFourFetch = new GiphyFetch(FOUR_O_FOUR_API_KEY)

const Error404 = () => {
    const fetchGifs = (offset: number) => fourOHFourFetch.trending({ offset })
    return (
        <>
            <GlobalStyle />
            <Container>
                <img src={(window as any).STATIC_URL + errorText} />
                <Message>
                    <p>Oops! There’s nothing here. Looking for GIFs</p>
                    <p>that DO exist? Here are our GIFs trending today!</p>
                </Message>
                <Arrow className="ss-icon ss-navigatedown" />
                <Grid columns={4} fetchGifs={fetchGifs} />
                <Footer>
                    <Button href="/">Continue to Our Homepage</Button>
                </Footer>
            </Container>
        </>
    )
}

export const Error403 = () => {
    return (
        <>
            <GlobalStyle />
            <Container>
                <img src={(window as any).STATIC_URL + errorText} />
                <Message>
                    <p>
                        An internal error occurred. Please <a href={location.href}>refresh</a> the page.
                    </p>
                </Message>
                <Button href="/" is403={true}>
                    Continue to Our Homepage
                </Button>
            </Container>
        </>
    )
}

export default Error404
